import React from 'react'
import { Edit } from 'react-feather'
import { useRewardsPermissions } from 'src/lib/access-permission-hooks/useRewardsPermissions'

interface RewardConfigTileProps {
  header: JSX.Element
  subHeader: JSX.Element
}

const RewardConfigTile: React.FC<RewardConfigTileProps> = ({ header, subHeader }) => {
  const { canEditSetupRewards } = useRewardsPermissions()

  return (
    <div className='flex flex-col w-full p-3 cursor-pointer hover:bg-gray-lightest hover:rounded-[inherit]'>
      <div className='flex flex-row items-center justify-between w-full'>
        <h3 className='font-medium text-coal-dark font-sm'>{header}</h3>
        {canEditSetupRewards && <Edit size='32' className='stroke-[2.5px] scale-50 cursor-pointer' color='#6E6E6E' />}
      </div>
      <p className='text-[#949494] font-sm'>{subHeader}</p>
    </div>
  )
}

export default RewardConfigTile
